import { useState } from "react";
import { Eye, LogOut, Menu, X } from "lucide-react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePortal } from "./PortalContext";
import "./portal.css";

const NAV = [
  { to: "", label: "Home", end: true },
  { to: "evaluations", label: "Evaluations" },
  { to: "team", label: "Your TAG team" },
  { to: "account", label: "Account" },
];

export default function ClientPortalShell({ base }) {
  const { logout, user } = useAuth();
  const portal = usePortal();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const clientName = portal.account?.client?.name || "";

  if (portal.error) {
    return (
      <div className="cp-root" data-testid="client-portal-error">
        <div className="cp-empty"><h2>We couldn't open your portal</h2><p>{portal.error}</p><button type="button" className="cp-btn cp-btn-primary" onClick={() => logout()}>Sign out</button></div>
      </div>
    );
  }

  return (
    <div className="cp-root" data-testid="client-portal-shell">
      {portal.preview && (
        <div className="cp-preview-banner" data-testid="client-preview-banner">
          <Eye size={14} /> Client view preview — this is exactly what {clientName || "the client"} sees{portal.account?.persona?.name ? ` (as ${portal.account.persona.name})` : ""}. Requests and messages are disabled here.
          <button type="button" className="cp-link-button" data-testid="client-preview-exit" onClick={() => navigate("/client-portal-preview")}>Exit preview</button>
        </div>
      )}
      <header className="cp-header">
        <div className="cp-brand">
          <Link to={base} className="cp-wordmark" data-testid="portal-wordmark">TAGForce</Link>
          <span className="cp-brand-divider" />
          <span className="cp-client-name" data-testid="portal-client-name">{clientName.toUpperCase()}</span>
        </div>
        <nav className={`cp-nav ${open ? "is-open" : ""}`} data-testid="portal-nav">
          {NAV.map((item) => (
            <NavLink key={item.label} to={`${base}${item.to ? `/${item.to}` : ""}`} end={item.end} className={({ isActive }) => `cp-nav-link ${isActive ? "is-active" : ""}`} data-testid={`portal-nav-${item.label.toLowerCase().replaceAll(" ", "-")}`} onClick={() => setOpen(false)}>
              {item.label}
            </NavLink>
          ))}
          <Link to={`${base}/new-request`} className="cp-btn cp-btn-light" data-testid="portal-nav-new-request" onClick={() => setOpen(false)}>New request</Link>
          {portal.preview ? (
            <span className="cp-nav-link cp-signout" data-testid="portal-preview-persona">Previewing as {portal.account?.persona?.name || "the client contact"}</span>
          ) : (
            <button type="button" className="cp-nav-link cp-signout" data-testid="portal-sign-out" onClick={() => logout()}><LogOut size={14} /> Sign out{user?.first_name ? ` (${user.first_name})` : ""}</button>
          )}
        </nav>
        <button type="button" className="cp-menu-toggle" aria-label="Menu" data-testid="portal-menu-toggle" onClick={() => setOpen((v) => !v)}>{open ? <X size={20} /> : <Menu size={20} />}</button>
      </header>
      <main className="cp-main">
        <Outlet />
      </main>
    </div>
  );
}
